import { on } from "@ngrx/store";
import { PagesStore } from "../../pages.state";
import { QuoteSubscriptionCreateActions } from "./quote-subscription-create.actions";
import { initialQuoteSubscriptionCreateState } from "./quote-subscription-create.state";

// ============================================================================
// QUOTE SUBSCRIPTION CREATE REDUCER (array format for spreading in pages reducer)
// ============================================================================

const loadPriceEstimate = on(QuoteSubscriptionCreateActions.loadPriceEstimate, (state: PagesStore) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, loading: true },
}));

const loadPriceEstimateSuccess = on(QuoteSubscriptionCreateActions.loadPriceEstimateSuccess, (state: PagesStore, { response }) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, priceEstimate: response, loading: false },
}));

const loadPriceEstimateFailure = on(QuoteSubscriptionCreateActions.loadPriceEstimateFailure, (state: PagesStore) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, loading: false },
}));

const resetPriceEstimate = on(QuoteSubscriptionCreateActions.resetPriceEstimate, (state: PagesStore) => ({
    ...state,
    quoteSubscriptionCreate: initialQuoteSubscriptionCreateState,
}));

const selectSalesPerson = on(QuoteSubscriptionCreateActions.selectSalesPerson, (state: PagesStore, { salesPerson }) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, salesPerson },
}));

const selectDeal = on(QuoteSubscriptionCreateActions.selectDeal, (state: PagesStore, { deal }) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, deal, loadingDealCustomer: !!deal?.customerCode, dealCustomerError: null },
}));

const loadDealCustomerSuccess = on(QuoteSubscriptionCreateActions.loadDealCustomerSuccess, (state: PagesStore) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, loadingDealCustomer: false },
}));

const loadDealCustomerFailure = on(QuoteSubscriptionCreateActions.loadDealCustomerFailure, (state: PagesStore, { error }) => ({
    ...state,
    quoteSubscriptionCreate: { ...state.quoteSubscriptionCreate, loadingDealCustomer: false, dealCustomerError: error },
}));

export const quoteSubscriptionCreateReducer = [
    loadPriceEstimate,
    loadPriceEstimateSuccess,
    loadPriceEstimateFailure,
    resetPriceEstimate,
    selectSalesPerson,
    selectDeal,
    loadDealCustomerSuccess,
    loadDealCustomerFailure,
];
